module.exports = __webpack_public_path__ + "static/media/icon_send_money.4bd99fe5.png";